class OsanoTrigger {
    constructor(trigger) {
        this.trigger = trigger;
        this.trigger.addEventListener('click', this.openModal)
    }

    openModal(event) {
        event.preventDefault();
        Osano.cm.showDoNotSell();
        const closeButtonDialog = document.querySelector('.osano-cm-info-dialog .osano-cm-close');
        closeButtonDialog?.focus();
    }
};

window.addEventListener('load', () => {
    document.querySelectorAll('.js-osano-trigger').forEach(link => new OsanoTrigger(link));
});